import React from "react";
import { useParams } from "react-router-dom";

import RestaurantDetail from "../restaurant/RestaurantDetail";
import EatsAdminLayout from "./EatsAdminLayout";

const EatsAdminRestaurantDetailPage = () => {
  const { restaurantId } = useParams();

  return (
    <EatsAdminLayout activeTab="restaurants" flushMain>
      <RestaurantDetail restaurantId={restaurantId} embeddedInAdmin />
    </EatsAdminLayout>
  );
};

export default EatsAdminRestaurantDetailPage;
